<template>
  <nav>
    <div class="nav-inner">
      <template v-if="isFinance">
        <router-link to="/" class="nav-logo">Art Finance <span>Structural Health Monitoring</span></router-link>
        <ul class="nav-links">
          <li><router-link to="/live">Live</router-link></li>
          <li><router-link to="/cases">Cases</router-link></li>
          <li><router-link to="/session/signin">Sign in</router-link></li>
          <li><a href="https://artrofimov.xyz">Art main</a></li>
        </ul>
      </template>
      <template v-else>
        <router-link to="/" class="nav-logo">Art <span>Structural Health Monitoring</span></router-link>
        <ul class="nav-links">
          <li><router-link to="/session/signin">Sign in</router-link></li>
          <!-- <li><router-link to="/live">Finance Live</router-link></li> -->
          <!-- <li><router-link to="/alerts">Alerts</router-link></li>
          <li><router-link to="/divergence">Divergence</router-link></li> -->
          <!-- <li><router-link to="/">← About</router-link></li> -->
        </ul>
      </template>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const isFinance = computed(() => {
  if (typeof window === 'undefined') return false
  return window.location.hostname === 'finance.artrofimov.xyz'
})
</script>